import type { TrackingContext } from './types';

export const ZendeskScriptTag = {
  tag: 'script',
  id: 'ze-snippet',
  src: 'https://static.zdassets.com/ekr/snippet.js?key=7c7977b2-bfb9-45a1-9b9b-d46d80205b3e',
  type: 'text/javascript',

  inject(element: HTMLElement, ctx: TrackingContext) {
    if (ctx.authenticated) {
      document.head.appendChild(element);
    }
  },

  onScriptLoad(_: TrackingContext) {
    // prevent all widget functionality until our hooks are set
    window.zE?.('messenger', 'hide');
    window.zE?.('messenger', 'close');
  },

  cleanup() {
    window.zE?.('messenger', 'logoutUser');
  },
};
